import http from "utils/http";
import { digiBasic } from "constants/endpoints";

const getDigibasicConstraints = () => {
  const ENDPOINT = digiBasic.getDigibasicConstraints();
  const { REACT_APP_API_BASE_URL: API_BASE_URL } = process.env;
  return http.get(`${API_BASE_URL}${ENDPOINT}`);
};

export default getDigibasicConstraints;
